import { initAnalytics, trackEvent, trackPageview } from './analytics'

initAnalytics()
trackPageview(window.location.pathname)

document.addEventListener('click', (event) => {
  const target = event.target
  if (!(target instanceof Element)) return

  const link = target.closest<HTMLAnchorElement>('a[href^="mailto:"]')
  if (!link) return

  trackEvent('email_click', {
    location: link.dataset.analyticsLocation || window.location.pathname,
  })
})
